module.exports = __webpack_public_path__ + "home_s2.png?9379fece72b2556fce61074f143302f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s2.png
// module id = 48
// module chunks = 0